import React, { useState, useEffect, createContext, useContext } from 'react';
// TO BE USED IN GATSBY PROJECT TO PROVIDE LANGUAGE CONTEXT

/** Detect browser language (client-side only) */
function detectBrowserLanguage() {
  if (typeof navigator === 'undefined') return 'en';
  const lang = navigator.language || '';
  if (lang === 'de' || lang === 'de-DE') return 'de';
  if (lang === 'fr' || lang === 'fr-FR') return 'fr';
  return 'en';
}

const LanguageContextProvider = ({ children }) => {
  // Always start with 'en' for SSR safety — browser language is applied after mount
  const [state, setState] = useState({
    lang: 'en',
    wasSwitched: false,
  });

  // Detect browser language after mount (client-side only)
  useEffect(() => {
    const browserLang = detectBrowserLanguage();
    if (browserLang !== 'en') {
      setState(prev => prev.wasSwitched ? prev : { lang: browserLang, wasSwitched: false });
    }
  }, []);

  return (
    <LanguageContext.Provider value={[state, setState]}>
      {children}
    </LanguageContext.Provider>
  );
};

const LanguageContext = createContext();

const useLanguageContext = () => {
  const [state, setState] = useContext(LanguageContext);

  const switchLanguage = currentLang => {
    setState({
      lang: currentLang,
      wasSwitched: true,
    });
  };

  return [state, switchLanguage];
};

export { useLanguageContext };

export default LanguageContextProvider;
